export const paypalClientId = process.env.REACT_APP_PAYPAL_CLIENT_ID
export const paypalPlanId = process.env.REACT_APP_PAYPAL_PLAN_ID
export const isPaypalConfigured = Boolean(paypalClientId && paypalPlanId)

let loaderPromise = null

export function loadPaypalSdk() {
  if (window.paypal) {
    return Promise.resolve(window.paypal)
  }

  if (!loaderPromise) {
    loaderPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(paypalClientId)}&vault=true&intent=subscription`
      script.async = true
      script.onload = () => resolve(window.paypal)
      script.onerror = () => reject(new Error('No se pudo cargar el SDK de PayPal'))
      document.body.appendChild(script)
    })
  }

  return loaderPromise
}
